export default __webpack_public_path__ + "static/media/NQPHN-commissioned-services-map-icons_First Nations health.b15bee47.png";